import { render, staticRenderFns } from "./ItemSelected.vue?vue&type=template&id=de15d9e2&scoped=true"
import script from "./ItemSelected.vue?vue&type=script&lang=js"
export * from "./ItemSelected.vue?vue&type=script&lang=js"
import style0 from "./ItemSelected.vue?vue&type=style&index=0&id=de15d9e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de15d9e2",
  null
  
)

export default component.exports